module.exports = __webpack_public_path__ + "static/arrunada-logo-horizontal-4d4d9b0519c2a35109a597b2608ee09f.svg";